module.exports = __webpack_public_path__ + "img/adshow.1d297cbc.png";